import { UpdateMetadataFieldRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { LIST_ALL_METADATA_FIELDS_QUERY_KEY } from './useListAllMetadataFields';

export const useUpdateMetadataField = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const { mutate, isPending, error } = useMutation({
    mutationFn: ({ fieldId, data }: { fieldId: string; data: UpdateMetadataFieldRequest }) =>
      api.metadata.updateMetadataField(getTenantId(), fieldId, data),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [LIST_ALL_METADATA_FIELDS_QUERY_KEY],
        exact: false,
      });
      onSuccess?.();
    },
    onError: (error: AxiosError<{ message: string }>) => {
      onError?.(error.response?.data.message ?? 'Failed to update metadata field');
    },
  });

  return {
    updateMetadataField: mutate,
    isUpdating: isPending,
    updateError: error as AxiosError<{ message: string }>,
  };
};
